import axois from 'axios';
import { getLogoutFunction } from '../services/auth-service';

const client = axois.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Intercepting request
client.interceptors.request.use(async (config) => {

    if (config.url?.includes('/login')) {
        return config;
    }

    const user = localStorage.getItem('user');

    const { token } = user ? JSON.parse(user) as any : {};
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;

}, (error) => {
    return Promise.reject(error);
});

// Intercepting response
client.interceptors.response.use(
    (response) => response, 
    (error) => {

        if (axois.isCancel(error)) {
            return Promise.reject('User has cancelled the request.');
        }

        if (error?.response?.status === 401) {
            // logout and redirect
            const logout = getLogoutFunction();
            if (logout) logout(); 
        }

        return Promise.reject(error);
    }
);

export default client;